import * as React from 'react';
import { Tab } from '../../internal/Tab/Tab';
import { ScrollTrack } from '../../internal/ScrollTrack/ScrollTrack';

export interface ITabsProps {
  /**
   * value активного таба
   */
  activeTab: string;
  /**
   * Массив табов
   */
  tabs: ITabProps[];
  /**
   * Компонент не хранит активное состояние, для установке нового активного состояния используется onChange,
   * передает в качестве аргумента значение по которому был сделан клик/тап
   */
  onChange(value: string): void;
}

export interface ITabProps {
  /**
   * Идентификатор таба, используется для определения активного таба, передается в onChange при изменении
   */
  value: string;
  /**
   * Отображается в интерфейсе
   */
  title: React.ReactText;
  count?: React.ReactText;
  /**
   * Задисейбленый таб невозможно выбрать, для него не вызваются обработчики
   */
  disabled?: boolean;
}

const TabsComponent: React.FC<ITabsProps> = ({ activeTab, tabs, onChange }) => {
  const [focusVisible, setFocusVisible] = React.useState(false);

  const onClick = ({ e, value }: { e: React.MouseEvent; value: string }) => {
    setFocusVisible(false);
    onChange(value);
  };

  return (
    <ScrollTrack setFocusVisible={setFocusVisible} activeTab={activeTab}>
      <>
        {tabs.map(({ value, title, count, disabled }) => (
          <Tab
            key={value}
            title={title}
            count={count}
            disabled={disabled}
            active={value === activeTab}
            focusVisible={focusVisible}
            onClick={e => onClick({ e, value })}
          />
        ))}
      </>
    </ScrollTrack>
  );
};

/**
 * Компонент для рендера табов со стрелками прокрутки
 */
export const Tabs = React.memo(TabsComponent);
